import React from "react";

const DashboardLineIcon = () => (
	<g>
		<path d='M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z' />
	</g>
);

export default DashboardLineIcon;
